import {GET, POST} from '../index'

export const getContactList = (data) => {
  return GET('/contact/list', data)
}

export const updateContact = (data) => {
  return POST('/contact/update', data)
}



// WEBPACK FOOTER //
// ./src/api/contact/index.js